// Keep these in selectability order: https://www.mariowiki.com/Mario_Kart_8_Deluxe#Available_parts
export const TIRES = [
  //                                                                  Speed x4,      Acc, Wt,    Handling x4,    Trac, Mini-Turbo, Invincibility
  // row 1
  [['Roller', 'Azure Roller'],                                        0, 3, 3, 0,    6,   0,     4, 4, 4, 4,     4,    6,          0],
  // row 2
  [['Button', 'Leaf Tires (Leaf Tyres)'],                             1, 2, 2, 2,    5,   0,     3, 3, 2, 4,     3,    5,          3],
  // row 3
  [['Cushion'],                                                       1, 1, 4, 1,    4,   1,     2, 1, 3, 2,     6,    5,          6],
  [['Sponge'],                                                        1, 1, 4, 1,    4,   1,     2, 1, 3, 2,     6,    5,          4],
  // row 4
  [['GLA Tires (GLA Wheels)'],                                        2, 3, 3, 2,    4,   2,     3, 3, 3, 3,     5,    4,          5],
  [['Standard (Normal)', 'Blue Standard (Normal Blue)'],              2, 3, 3, 2,    4,   2,     3, 3, 3, 3,     5,    4,          4],
  // row 5
  [['Slim', 'Wood (Wooden)', 'Crimson Slim'],                         3, 2, 2, 4,    2,   2,     4, 4, 4, 3,     1,    3,          5],
  // row 6
  [['Monster', 'Hot Monster (Funky Monster)'],                        3, 2, 1, 2,    2,   4,     0, 1, 1, 0,     7,    3,          6],
  [['Ancient Tires (Ancient Tyres)'],                                 3, 2, 1, 2,    2,   4,     0, 1, 1, 0,     7,    3,          5],
  // row 7
  [['Off-Road', 'Retro Off-Road', 'Triforce Tires (Triforce Tyres)'], 3, 4, 1, 2,    3,   3,     1, 1, 2, 2,     6,    3,          6],
  // row 8
  [['Slick', 'Cyber Slick'],                                          4, 0, 0, 4,    1,   3,     2, 0, 1, 2,     0,    2,          5],
  // row 9
  [['Metal'],                                                         4, 3, 2, 1,    0,   4,     2, 2, 0, 1,     2,    2,          6],
  [['Gold Tires (Gold Wheels)'],                                      4, 3, 2, 1,    0,   4,     2, 2, 0, 1,     2,    2,          5]
];
